import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@mui/material';
import { Button, Dialog } from '../../../components/ui';

export default function UserOrganisationDetailDialog({ open, onClose, organisation }) {
  const org =
    typeof organisation === 'string'
      ? { name: organisation }
      : organisation || null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Organisation Details"
      actions={
        <Button variant="primary" onClick={onClose}>
          Close
        </Button>
      }
    >
      {org ? (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={700}>
              Organisation Name
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {org.name || 'N/A'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={700}>
              Email Address
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {org.email || 'N/A'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={700}>
              Mobile No
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {org.mobileNo || 'N/A'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={700}>
              Address
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {org.address || 'N/A'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={700}>
              Reference Name
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {org.referenceName || 'N/A'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={700}>
              Reference Mobile No
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {org.referenceMobile || 'N/A'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={700}>
              Reference Email
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {org.referenceEmail || 'N/A'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" fontWeight={700}>
              Category
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {org.category || 'N/A'}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" fontWeight={700}>
              Comments
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {org.comments || 'N/A'}
            </Typography>
          </Grid>
        </Grid>
      ) : (
        <Typography variant="body2" color="text.secondary">
          No organisation details available.
        </Typography>
      )}
    </Dialog>
  );
}

UserOrganisationDetailDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  organisation: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};
